/* DeskRebel BRUTAL FX — kinetische Effekte. Keine externen Libraries, respektiert prefers-reduced-motion. */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var root = document.documentElement;
  if (RM) { root.classList.add('br-rm'); return; }
  root.classList.add('br-fx');

  /* ---------- 1. Reveal: Titel-Wipe + Karten-Stagger + Zahlen-Tacho ---------- */
  var titles = document.querySelectorAll('.section-title, .hb-facts b, .cart-page-title, .dr-pt-main');
  titles.forEach(function (el) {
    el.classList.add('br-wipe');
    var bar = document.createElement('i');
    bar.className = 'br-sweep'; bar.setAttribute('aria-hidden', 'true');
    el.appendChild(bar);
  });
  var cardSel = '.dr-lu-card, .dr-rc-card, .dr-xb-item, .dr-tm-card, .dr-bp-card, .category-card, .stat-item, .faq-item, .pv-sec';
  var groups = {};
  document.querySelectorAll(cardSel).forEach(function (el) {
    var p = el.parentElement; var k = p ? (p.__brk || (p.__brk = Math.random().toString(36).slice(2))) : 'x';
    groups[k] = (groups[k] || 0) + 1;
    el.style.setProperty('--br-i', groups[k] - 1);
    el.classList.add('br-card');
  });

  function countUp(el) {
    var tn = null;
    for (var i = 0; i < el.childNodes.length; i++) { if (el.childNodes[i].nodeType === 3 && /\d/.test(el.childNodes[i].nodeValue)) { tn = el.childNodes[i]; break; } }
    if (!tn) return;
    var raw = tn.nodeValue, m = raw.match(/-?−?\d+/);
    if (!m) return;
    var neg = /[-−]/.test(m[0]); var target = parseInt(m[0].replace(/[^\d]/g, ''), 10);
    var pre = raw.slice(0, m.index), post = raw.slice(m.index + m[0].length);
    var t0 = null, dur = 900;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var v = Math.round(target * (1 - Math.pow(1 - p, 4)));
      tn.nodeValue = pre + (neg ? '−' : '') + v + post;
      if (p < 1) requestAnimationFrame(step);
    }
    tn.nodeValue = pre + (neg ? '−' : '') + '0' + post;
    requestAnimationFrame(step);
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target; el.classList.add('br-in'); io.unobserve(el);
      if (el.classList.contains('stat-number')) countUp(el);
    });
  }, { threshold: 0, rootMargin: '0px 0px -8% 0px' }) : null;
  document.querySelectorAll('.br-wipe, .br-card, .stat-number').forEach(function (el) {
    if (io) io.observe(el); else el.classList.add('br-in');
  });
  /* Sicherheitsnetz: Elemente oberhalb des sichtbaren Bereichs (z. B. nach Anker-Sprung) sofort zeigen */
  function flushAbove() {
    document.querySelectorAll('.br-wipe:not(.br-in), .br-card:not(.br-in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('br-in'); if (io) io.unobserve(el); }
    });
  }
  window.addEventListener('scroll', function () { if (!flushAbove.t) flushAbove.t = setTimeout(function () { flushAbove.t = 0; flushAbove(); }, 150); }, { passive: true });
  window.addEventListener('load', flushAbove);

  /* ---------- 2. Laufbaender: scroll-getrieben, Tempo + Schraeglage nach Scroll-Speed ---------- */
  var tapes = [].slice.call(document.querySelectorAll('.hb-tape, .dr-band'));
  var lastY = window.scrollY, vel = 0, skew = 0;
  var tracks = tapes.map(function (t, i) {
    var tr = t.querySelector('.hb-tape-track, .dr-band-track');
    if (!tr) return null;
    tr.style.animation = 'none';
    return { el: tr, tape: t, x: 0, dir: (t.classList.contains('hb-tape-2') ? 1 : -1), base: 0.6 + i * 0.12, w: 0 };
  }).filter(Boolean);
  function measure() { tracks.forEach(function (o) { o.w = o.el.scrollWidth / 2 || 1; if (o.dir > 0) o.x = -o.w; }); }
  measure(); window.addEventListener('resize', measure);

  /* ---------- 3. Hero: Schatten folgt der Maus ---------- */
  var frame = document.getElementById('hb-frame');
  var mx = 0, my = 0, sx = 0, sy = 0;
  if (frame && FINE) {
    window.addEventListener('mousemove', function (e) {
      var r = frame.getBoundingClientRect();
      mx = ((e.clientX - (r.left + r.width / 2)) / window.innerWidth) * -36;
      my = ((e.clientY - (r.top + r.height / 2)) / window.innerHeight) * -36;
    }, { passive: true });
  }

  /* ---------- 4. Brutal-Cursor (nur Maus) ---------- */
  var cur = null, cx = -100, cy = -100, tx = -100, ty = -100;
  if (FINE) {
    cur = document.createElement('div'); cur.id = 'br-cursor'; cur.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cur);
    window.addEventListener('mousemove', function (e) { tx = e.clientX; ty = e.clientY; cur.classList.add('on'); }, { passive: true });
    document.addEventListener('mouseleave', function () { cur.classList.remove('on'); });
    document.addEventListener('mouseover', function (e) {
      var h = e.target.closest && e.target.closest('a, button, .dr-lu-card, .dr-rc-card, [role="button"], input, label');
      cur.classList.toggle('big', !!h);
    });
    /* ---------- 5. Klick-Explosion aus harten Quadraten ---------- */
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      var ring = document.createElement('i'); ring.className = 'br-ring';
      ring.style.left = e.clientX + 'px'; ring.style.top = e.clientY + 'px';
      document.body.appendChild(ring); setTimeout(function () { ring.remove(); }, 450);
      for (var k = 0; k < 8; k++) {
        var s = document.createElement('i'); s.className = 'br-shard';
        var a = (k / 8) * Math.PI * 2 + Math.random() * 0.5, d = 40 + Math.random() * 50;
        s.style.left = e.clientX + 'px'; s.style.top = e.clientY + 'px';
        s.style.setProperty('--dx', Math.cos(a) * d + 'px'); s.style.setProperty('--dy', Math.sin(a) * d + 'px');
        s.style.setProperty('--r', (Math.random() * 360 | 0) + 'deg');
        document.body.appendChild(s); (function (n) { setTimeout(function () { n.remove(); }, 480); })(s);
      }
    });
  }

  /* ---------- Haupt-Loop ---------- */
  var prog = document.getElementById('scroll-progress');
  function loop() {
    var y = window.scrollY, dy = y - lastY; lastY = y;
    vel += (dy - vel) * 0.18;
    skew += (Math.max(-8, Math.min(8, vel * 0.35)) - skew) * 0.15;
    for (var i = 0; i < tracks.length; i++) {
      var o = tracks[i], sp = (o.base + Math.min(14, Math.abs(vel) * 0.35)) * o.dir;
      o.x += sp;
      if (o.dir < 0 && o.x <= -o.w) o.x += o.w;
      if (o.dir > 0 && o.x >= 0) o.x -= o.w;
      o.el.style.transform = 'translate3d(' + o.x.toFixed(1) + 'px,0,0)';
      o.tape.style.transform = 'skewY(' + (skew * (o.dir < 0 ? -0.35 : 0.35)).toFixed(2) + 'deg)';
    }
    if (frame) {
      sx += (mx - sx) * 0.12; sy += (my - sy) * 0.12;
      frame.style.setProperty('--sx', (16 + sx).toFixed(1) + 'px');
      frame.style.setProperty('--sy', (16 + sy).toFixed(1) + 'px');
    }
    if (cur) { cx += (tx - cx) * 0.28; cy += (ty - cy) * 0.28; cur.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)'; }
    if (prog) { var h = document.documentElement.scrollHeight - window.innerHeight; prog.style.width = (h > 0 ? (y / h) * 100 : 0) + '%'; }
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);
})();
